import { useCallback, useEffect } from 'react';

import ProductCard from 'components/common/ProductCard';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { evRecommendationClick, evRecommendationImpressionWrapper } from 'events/recommendations';
import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';

import css from 'styles/components/search/inlineRecosNpc.scss';

/*
  Once `npc` AKA HYDRA_NEW_PRODUCT_CARD is finished you can delete either
  this component or the legacy SearchInlineRecos component.
*/
export const SearchInlineRecosNpc = ({ inlineRecos = {}, recommendations = {}, heartsInfo, msaImageParams, searchTerm, hydraCustAlsoBoughtThese, hydraHeartsStars }) => {

  const recos = hydraCustAlsoBoughtThese ? recommendations?.items : inlineRecos?.recos;
  const title = hydraCustAlsoBoughtThese ? recommendations?.title : inlineRecos?.title;
  const recoSource = hydraCustAlsoBoughtThese ? 'ZAPPOS_DATA_SCIENCE' : 'EP13N';

  const handleInlineRecoClick = useCallback(({ index, styleId, productId }) => {
    trackEvent('TE_SEARCH_INLINE_RECO_CLICK', `styleId:${styleId}productIndex:${index}:searchTerm:${searchTerm}`);
    track(() => ([
      evRecommendationClick, {
        index: index + 1,
        recommendationType: 'PRODUCT_RECOMMENDATION',
        recommendationValue: productId,
        recommendationSource: recoSource,
        widgetType: 'SIMILAR_PRODUCT_WIDGET'
      }
    ]));
  }, [recoSource, searchTerm]);

  useEffect(() => {
    const styleIds = recos.map(reco => reco.styleId);
    trackEvent('TE_SEARCH_INLINE_RECOS_VIEW', `styles:${styleIds}:searchTerm:${searchTerm}`);
    const recommendationImpression = [{
      numberOfRecommendations: styleIds.length,
      recommendationType: 'PRODUCT_RECOMMENDATION',
      recommendationSource: recoSource,
      widgetType: 'SIMILAR_PRODUCT_WIDGET'
    }];
    track(() => ([ evRecommendationImpressionWrapper, { recommendationImpression } ]));
  }, [recoSource, recos, searchTerm]);
  return !!recos?.length && (
    <aside className={css.container} data-reco-count={recos.length}>
      {title && <h2>{title}</h2>}
      <div className={css.recos} data-test-id={recoSource}>
        {recos.map((reco, index) => {
          if (index < 4) {
            const { styleId, productId, link, productUrl } = reco;
            const url = link || productUrl; // if cabt wins won't need to explicitly send this; handled by ProductCard.jsx
            return (
              <ProductCard
                {...reco}
                hearts={heartsInfo}
                msaImageParams={msaImageParams}
                key={styleId + productId}
                className={css.productCardOverride}
                imageNoBackground={true}
                productUrl={url}
                onClick={() => handleInlineRecoClick({ index, styleId, productId })}
                hydraHeartsStars={hydraHeartsStars}
              />
            );
          }
          return null;
        })}
      </div>
    </aside>
  );
};

export default withErrorBoundary('SearchInlineRecosNpc', SearchInlineRecosNpc);
